import React from 'react';
import { Link } from 'react-router-dom';
import { PieChart, Pie, Cell, Tooltip, ResponsiveContainer, Legend } from 'recharts';
import { formatNum } from '../../utils/dashboardFormatters';

const COLORS = ['#16A34A', '#F59E0B', '#DC2626'];

export default function DashboardCircleHealth({ circleHealth, loading }) {
  const complete = Number(circleHealth?.complete ?? 0);
  const incomplete = Number(circleHealth?.incomplete ?? 0);
  const pending = Number(circleHealth?.pendingInvites ?? 0);
  const total = complete + incomplete;
  const pieData = [
    { name: 'Complete', value: complete },
    { name: 'Incomplete', value: incomplete },
  ].filter((d) => d.value > 0);

  return (
    <div className="db-card">
      <div className="db-card-header">
        <div className="db-card-title">
          <i className="fas fa-circle-nodes" style={{ color: '#0891B2' }} />
          Trusted circle health
        </div>
        <Link to="/trusted-circles" className="db-card-link">
          Manage circles
        </Link>
      </div>
      <div className="db-card-body">
        {loading ? (
          <div className="db-skeleton-block" />
        ) : total === 0 && pending === 0 ? (
          <div className="db-chart-empty">No trusted circles yet</div>
        ) : (
          <>
            <div className="db-chart-wrap" style={{ minHeight: 200 }} role="img" aria-label="Circle health chart">
              <ResponsiveContainer width="100%" height={200}>
                <PieChart>
                  <Pie
                    data={pieData.length ? pieData : [{ name: 'No data', value: 1 }]}
                    cx="50%"
                    cy="50%"
                    innerRadius={50}
                    outerRadius={72}
                    paddingAngle={2}
                    dataKey="value"
                  >
                    {(pieData.length ? pieData : [{ name: 'No data', value: 1 }]).map((_, i) => (
                      <Cell key={i} fill={pieData.length ? COLORS[i % COLORS.length] : '#E2E8F0'} />
                    ))}
                  </Pie>
                  <Tooltip formatter={(v) => formatNum(v)} />
                  <Legend wrapperStyle={{ fontSize: 12 }} />
                </PieChart>
              </ResponsiveContainer>
            </div>
            <div className="db-health-stats">
              <div className="db-health-stat">
                Complete
                <strong>{formatNum(complete)}</strong>
              </div>
              <div className="db-health-stat">
                Incomplete
                <strong>{formatNum(incomplete)}</strong>
              </div>
              <div className="db-health-stat">
                Pending invites
                <strong>{formatNum(pending)}</strong>
              </div>
              {circleHealth?.avgSize != null && (
                <div className="db-health-stat">
                  Avg circle size
                  <strong>{circleHealth.avgSize}</strong>
                </div>
              )}
            </div>
          </>
        )}
      </div>
    </div>
  );
}
